import { render, staticRenderFns } from "./TiposProductoBase.vue?vue&type=template&id=38a7d4e2&"
import script from "./TiposProductoBase.vue?vue&type=script&lang=ts&"
export * from "./TiposProductoBase.vue?vue&type=script&lang=ts&"
import style0 from "./TiposProductoBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('38a7d4e2', component.options)
    } else {
      api.reload('38a7d4e2', component.options)
    }
    module.hot.accept("./TiposProductoBase.vue?vue&type=template&id=38a7d4e2&", function () {
      api.rerender('38a7d4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/TiposProducto/TiposProductoBase.vue"
export default component.exports